'use strict';

var defineProperty = require('../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var withStyles = require('../node_modules/@material-ui/core/esm/styles/withStyles.js');
var SvgIcon = require('../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var styles = {
  root: {
    width: 32,
    height: 32
  }
};

var SvgWrapper = function SvgWrapper(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 32 32'
  }, props), props.children);
};

var SvgWrapper$1 = withStyles(styles)(SvgWrapper);

module.exports = SvgWrapper$1;
